import { Component } from '@angular/core';

@Component({
  selector: 'kiss-content',
  template: '<router-outlet *ngIf="true"></router-outlet>',
})
export class KissContentComponent {}
